<template lang="pug">
  v-progress-circular(
    v-if="loading"
    class="m-auto"
    indeterminate
    color="primary"
    :size="100"
  )
  v-container#merchant(
    v-else-if="details"
    class="padded-bottom"
  )
    Review(
      id="review-card"
      v-if="dialog"
      :dialog="dialog"
      :merchantId="merchantId"
      :storeId="storeId"
      :merchantName="details.merchant_name"
      :storeName="details.store_name"
      :ownReview="ownReview"
      @close="close"
      @done="getReviewList"
    )
    .merchant-container
      DineInStore(
        :merchantId="merchantId"
        :storeId="storeId"
        :constraints="constraints[0]"
        :details="details"
      )
      .review-container
        h3.header-title Reviews
          v-btn(
            class="my-auto mx-2"
            small
            depressed
            color="accent"
            @click="review"
          ) {{ ownReview ? 'Update Review' : 'Add Review' }}
        v-list(
          v-if="ownReview"
          class="p-0"
        )
          v-list-item-group(
            v-model="selected"
            active-class="primary--text"
          )
            v-list-item(
              class="item"
              :key="ownReview.id"
              two-line
            )
              template(v-slot:default="{ active }")
                v-list-item-content
                  v-list-item-title.mb-4
                    span.review-comment {{ ownReview.review_comment }}
                  v-list-item-subtitle.d-flex.flex-column 
                    span.mb-2 {{ ownReview.customer_name }}
                    span(style="font-size: .8rem; font-weight: 400;") Reviewed: {{ $helpers.formatTime(ownReview.review_createdt) }}
                v-list-item-action
                  v-rating(
                    :value="parseFloat(ownReview.review_star)"
                    color="accent"
                    dense
                    half-increments
                    readonly
                    size="14"
                  )
            v-card(
              v-if="ownReview.review_reply"
              class="review-reply"
              color="accent lighten-2"
            )
              v-list-item(
                class="item"
                two-line
              )
                v-list-item-content
                  v-list-item-title.mb-4
                    span(style="font-size: 1rem; font-weight: 400;") {{ ownReview.review_reply }}
                  v-list-item-subtitle.text-white(style="font-size: .8rem; font-weight: 400;") Replied: {{ $helpers.formatTime(ownReview.review_modifydt) }}              
            v-divider(
              class="m-0"
            )
        v-list(
          class="p-0 mt-2"
        )
          v-list-item-group
            template(v-for="(r, index) in reviewList")
              v-list-item(
                class="item"
                :key="r.id"
                two-line
              )
                template(v-slot:default="{ active }")
                  v-list-item-content
                    v-list-item-title.mb-4
                      span.review-comment {{ r.review_comment }}
                    v-list-item-subtitle.d-flex.flex-column
                      span.mb-2 {{ r.customer_name }}
                      span(style="font-size: .8rem; font-weight: 400;") Reviewed: {{ $helpers.formatTime(r.review_createdt) }}
                  v-list-item-action
                    v-rating(
                      :value="parseFloat(r.review_star)"
                      color="accent"
                      dense
                      half-increments
                      readonly
                      size="14"
                    )
              v-card(
                v-if="r.review_reply"
                class="review-reply"
                color="accent lighten-2"
              )
                v-list-item(
                  class="item"
                  two-line
                )
                  v-list-item-content
                    v-list-item-title.mb-4
                      span(style="font-size: 1rem; font-weight: 400;") {{ r.review_reply }}
                    v-list-item-subtitle.text-white(style="font-size: .8rem; font-weight: 400;") Replied: {{ $helpers.formatTime(r.review_modifydt) }}              
              v-divider(
                class="m-0"
                v-if="index < review_list.length - 1"
                :key="index"
              )
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

import DineInStore from "@/views/dinein/DineInStore";
import Review from "@/views/merchant/Review";

export default {
  props: {
    decrypted: Object,
    details: Object,
    constraints: Array
  },
  components: {
    DineInStore,
    Review
  },
  watch: {
    details: {
      deep: true,
      // immediate: true,
      handler(val) {
        this.$store.commit("layout/setDisplayTitle", val.merchant_name);
      }
    }
  },
  data() {
    return {
      dialog: false,
      selected: 0,
      value: 1,
      banner_list: [],
      review_list: [],
      review_page: 1,
      selectedStore: null,
      selection: 1,
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    merchantId() {
      return this.decrypted.merchant_id;
    },
    storeId() {
      return this.decrypted.store_id;
    },
    ownReview() {
      return this.review_list.length
        ? this.review_list.filter(
            x => x.customer_id == this.$store.getters.customerId
          )[0]
        : null;
    },
    reviewList() {
      return this.review_list.length
        ? this.review_list.filter(
            x => x.customer_id != this.$store.getters.customerId
          )
        : [];
    }
  },
  mounted() {
    this.getReviewList();
  },
  methods: {
    review() {
      if (!this.$store.getters.isLoggedIn) {
        this.$swal(
          this.$t("error.login_first"),
          "Login before leaving review",
          "error"
        ).then(result => {
          if (result.isConfirmed) {
            this.$router.push("/login");
          }
        });
        return;
      } else {
        this.dialog = true;
      }
    },
    close() {
      this.dialog = false;
    },
    goback() {
      this.$router.push({
        name: "Merchant",
        params: {
          merchant: this.merchantId
        }
      });
      this.$store.commit("layout/setDisplayTitle", this.details.merchant_name);
    },
    getReviewList() {
      let url = config.reviewListUrl();

      var json = {
        params: {
          merchant_id: this.merchantId,
          store_id: this.storeId,
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.review_list = response.body.data;
                this.review_page = response.body.count;
              } else {
                this.$swal(
                  this.$t("error.get_merchant_review"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_merchant_review"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_merchant_review"),
            response.body.message,
            "error"
          );
        });
    },
    getBannerList() {
      let url = config.bannerUrl();

      var json = {
        params: {
          merchant_id: this.merchantId,
          store_id: this.merchantId,
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.banner_list = response.body.data;
              } else {
                this.$swal(
                  this.$t("error.get_merchant_banner"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_merchant_banner"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_merchant_banner"),
            response.body.message,
            "error"
          );
        });
    }
  }
};
</script>
